const { isEmpty, } = require('lodash');

module.exports = {
  fields: () => {
    return {
      name: {
        type: 'string',
        label: '名称',
        validations: {
          required: v => !isEmpty(v),
        },
      },
      body: {
        type: 'text',
        label: '本文',
        validations: {
          required: v => !isEmpty(v),
        },
        rows: 10,
      },
    };
  },
};
